import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

const PageCookiePolicy = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.cookie_policy]);
  });

  useEffect(() => {
    trackPageview({ title: 'Cookie Policy', path: props.path });
  }, []);

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.cookie_policy);
  });

  const { title = 'Cookie Policy', description = '' } = pageData?.content || {};

  return (
    <div className="blue-background cookie-policy">
      <div className="container">
        <SiteMetaData {...meta} />
        <h1 style={{ textAlign: 'center', marginBottom: 45 }}>{title}</h1>

        <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: description }} />

        <section className="cookie-policy__table">
          <div className="cookie-policy__table__col cookie-policy__table__col-1">
            <div className="cookie-policy__table__header">
              <h2>Cookie</h2>
            </div>
            <div className="cookie-policy__table__row">Google Analytics</div>
          </div>
          <div className="cookie-policy__table__col cookie-policy__table__col-2">
            <div className="cookie-policy__table__header">
              <h2>Duration</h2>
            </div>
            <div className="cookie-policy__table__row">Two years</div>
          </div>
          <div className="cookie-policy__table__col cookie-policy__table__col-3">
            <div className="cookie-policy__table__header">
              <h2>Purpose / Third Party Access</h2>
            </div>
            <div className="cookie-policy__table__row">
              <p>
                This cookie is used to collect information about how visitors use our Website. We use the information to
                compile reports and to help us improve our Website.
              </p>

              <p>
                The cookies collect information in an anonymous form, including the number of visitors to the Website,
                where visitors have come to the Website from and the pages they visited.
              </p>

              <p>
                Read Google's overview of privacy and safeguarding data{' '}
                <a href="https://support.google.com/analytics/answer/6004245" style={{ textDecoration: 'underline' }}>
                  here
                </a>
                .
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PageCookiePolicy;
